export default __webpack_public_path__ + "static/jardin3-0452d626c8e77f5b59dc4a6a6f9bb921.png";